<template>
  <div class="main-footer-container">
    <div class="main-footer">
      <div class="logo-container">
        <img src="@/assets/images/icons/proguides-by-aimlabs-icon-white.svg" alt="Proguides by Aimlabs Icon" />
      </div>
      <CompanyLinks />
      <GamesLinks />
      <!-- <div> -->
      <SocialLinks />
      <DownloadLinks />
      <!-- </div> -->
    </div>
    <!-- <GiftSection /> -->
  </div>
</template>

<script>
import CompanyLinks from "./CompanyLinks"
import GamesLinks from "./GamesLinks"
import SocialLinks from "./SocialLinks"
import DownloadLinks from "./DownloadLinks"
import GiftSection from "./GiftSection.vue"

export default {
  components: {
    CompanyLinks,
    GamesLinks,
    SocialLinks,
    DownloadLinks,
    GiftSection,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.main-footer-container {
  max-width: 108rem;
  padding: 3rem 2rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  @include tablet-down {
    flex-direction: column-reverse;
  }
  .main-footer {
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    @include phone-down {
      flex-direction: column;
    }
    .logo-container {
      min-width: 16.5rem;
      text-align: left;
      @include desktop-down {
        min-width: unset;
      }
      @include phone-down {
        margin-bottom: 3rem;
      }
      img {
        width: 4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/main_footer/MainFooter.vue